export var containerStyles = function containerStyles(justify) {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: "flex-".concat(justify),
    width: '100%'
  };
};